import React, { ReactNode } from 'react'
import styled from 'styled-components'

import { Card, CardContent, Grid as MuiGrid, IconButton, Typography } from '@material-ui/core'
import { spacing } from '@material-ui/system'
import {
  KeyboardArrowLeft as KeyboardArrowLeftIcon,
  KeyboardArrowRight as KeyboardArrowRightIcon,
} from '@material-ui/icons'
import AddOutlinedIcon from '@material-ui/icons/AddOutlined'
const Grid = styled(MuiGrid)(spacing)

interface PaginatedFilePreviewGalleryProps {
  title: string
  paginator: {
    loading: boolean
    data?: {
      count: number
      results: any[]
    }
    page: number
    pageSize: number | 'all'
    handlePageChange: (event: React.ChangeEvent<any>, newPage: number) => void
    handleSearchChange?: (event: React.ChangeEvent<any>, query: string) => void
  }
  getIdent: (item: any) => string
  renderItem: (item: any) => ReactNode
  onAdd?: () => void
}

export const PaginatedFilePreviewGallery = (props: PaginatedFilePreviewGalleryProps) => {
  const { getIdent, paginator, renderItem, title, onAdd } = props
  const numPages = paginator.pageSize === 'all' ? 1 : paginator?.data ? Math.ceil(paginator.data.count / paginator.pageSize) : 0

  return (
    <Card>
      <CardContent>
        <Grid justify="space-between" container>
          <Typography variant="h5" component="h3">
            {title}
          </Typography>
          {onAdd && (
            <IconButton onClick={onAdd}>
              <AddOutlinedIcon />
            </IconButton>
          )}
        </Grid>
        <Grid container alignItems="center" spacing={2} mt={6}>
          <Grid item xs={1}>
            <IconButton
              onClick={(event) => paginator.handlePageChange(event, paginator.page - 1)}
              disabled={paginator.page <= 1}
            >
              <KeyboardArrowLeftIcon />
            </IconButton>
          </Grid>
          {paginator?.data?.results.length ? (
            <Grid item container spacing={4} xs={10}>
              {paginator.data?.results &&
                paginator.data?.results.map((item) => (
                  <Grid key={getIdent(item)} item xs={3}>
                    {renderItem(item)}
                  </Grid>
                ))}
            </Grid>
          ) : (
            <Grid item container justify="center" xs={10}>
              <span>Nothing here yet.</span>
            </Grid>
          )}
          <Grid item xs={1}>
            <IconButton
              onClick={(event) => paginator.handlePageChange(event, paginator.page + 1)}
              disabled={paginator.page >= numPages}
            >
              <KeyboardArrowRightIcon />
            </IconButton>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
